import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faPaw } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import api from "../../../api/api";

const Feedback = ({ type, item }) => {
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [suggestions, setSuggestions] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
   const [isFeedback, setIsfeedback] = useState(true)

  const handleRatingChange = (newRating) => {
    setRating(newRating);
    setFeedback("");
    setSuggestions("");
  };

  const renderStars = () => (
    <div className="flex justify-center space-x-2 mt-4">
      {[1, 2, 3, 4, 5].map((star) => (
        <motion.button
          key={star}
          onClick={() => handleRatingChange(star)}
          whileHover={{ scale: 1.3, rotate: star % 2 === 0 ? -10 : 10 }}
          whileTap={{ scale: 0.9 }}
          className={`text-4xl transition-colors ${
            star <= rating ? "text-purple-600" : "text-gray-300"
          }`}
        >
          <FontAwesomeIcon icon={faStar} />
        </motion.button>
      ))}
    </div>
  );

  const handleSubmit = async () => {
    if (!rating) return;

    setIsSubmitting(true);
    setSuccessMessage(null);
    setErrorMessage(null);

    try {
      const response = await api.post("/feedback", {
        service_id: item.id,
        service_type: type,
        feedback_text: rating < 4 ? feedback : suggestions,
        rating,
      });

      if (!response.hasOwnProperty("status")) {
        setSuccessMessage(
          "Thank you for your feedback! 🐾 We’re so happy your pet enjoyed the experience!"
        );
        setRating(0);
        setFeedback("");
        setSuggestions("");
        setIsfeedback(false)
      }
      
    } catch (error) {
      setErrorMessage("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="text-center mt-8 mx-auto ">
      <div className="flex items-center justify-center mb-6 flex-col sm:flex-row">
        <FontAwesomeIcon
          icon={faPaw}
          size="3x"
          className="text-purple-600 mr-3"
        />
        <h3 className="text-3xl mt-2 sm:mt-0 font-bold text-gray-800">
          How Was Your Pet's Experience? 🐾
        </h3>
      </div>

      {/* Display success or error messages */}
      {successMessage && (
        <motion.div
          className="bg-green-100 text-green-700 py-3 px-6 rounded-lg mb-6 inline-block"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          {successMessage}
        </motion.div>
      )}
      {errorMessage && (
        <motion.div
          className="bg-red-100 text-red-700 py-3 px-6 rounded-lg mb-6 inline-block"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          {errorMessage}
        </motion.div>
      )}
      
      {/* Star Rating */}
      { isFeedback && (renderStars())}

      {/* Conditional feedback fields */}
      {isFeedback && rating > 0 && (
        <motion.div
          className="mt-4 flex flex-col items-center"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          {rating < 4 && (
            <div className="w-10/12">
              <label className="block text-gray-700 mb-1 font-medium text-lg">
                Oh no! What could we improve?
              </label>
              <textarea
                rows="3"
                placeholder="Tell us what didn't go paw-fectly..."
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div>
          )}
          {rating >= 4 && (
            <div className="w-10/12">
              <label className="block text-gray-700 mb-1 font-medium text-lg">
                Yay! What did you enjoy the most?
              </label>
              <textarea
                rows="3"
                placeholder="Share what made your pet wag their tail..."
                value={suggestions}
                onChange={(e) => setSuggestions(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div>
          )}
        </motion.div>
      )}
     
      {/* Submit button */}
      {isFeedback && (
         <div className="mt-6 flex justify-center">
        <motion.button
          onClick={handleSubmit}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="bg-purple-600 text-white px-6 py-3 rounded-full shadow-lg font-semibold flex items-center justify-center"
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            "Submitting..."
          ) : (
            <>
              <FontAwesomeIcon icon={faPaw} className="mr-2" /> Submit Feedback
            </>
          )}
        </motion.button>
      </div>
      )}
      
    </div>
  );
};

export default Feedback;
